import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Swiper, SwiperSlide as SwiperCoreSlide } from 'swiper/react'
import 'swiper/css'
import Button from 'src/shared/components/Button'
import { SliderContainer, Title, RowSlider, SwiperSlide, Card, Subtitle } from './styles'

const CategorySlider: React.FC = () => {
  const navigate = useNavigate()
  const [isPaused, setIsPaused] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 500)
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const images = Array.from({ length: 6 }, (_, idx) => `/images/categoriesHome/img${idx}.png`)
  const titles = [
    'Pinturas',
    'Acero',
    'Cables',
    'Tuberías, Válvulas y Conexiones',
    'Acabados',
    'Cemento',
  ]

  const handleRedirect = (title: string) => {
    const queryParam = title.replace(/ /g, '%20')
    navigate(`/products?categories=${queryParam}`)
  }

  return (
    <SliderContainer>
      <Subtitle className="animate__animated animate__fadeInUp">Principales Categorías</Subtitle>
      <Title style={{ marginTop: 0 }}>
        ¡Elige, haz clic y <span>construye!</span>
      </Title>

      {isMobile ? (
        <Swiper
          spaceBetween={24}
          slidesPerView={1.3}
          direction={'horizontal'}
          style={{ paddingBottom: 70 }}
        >
          {images.map((src, i) => {
            const title = titles[i]
            return (
              <SwiperCoreSlide key={i}>
                <Card image={src}>
                  <h3>{title}</h3>
                  <div>
                    <Button
                      equip="degraded"
                      size="small"
                      style={{ width: '150px', paddingBlock: 18, fontSize: 14 }}
                      onClick={() => handleRedirect(title)}
                    >
                      Ver productos
                    </Button>
                  </div>
                </Card>
              </SwiperCoreSlide>
            )
          })}
        </Swiper>
      ) : (
        <RowSlider
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          paused={isPaused}
        >
          {[...images, ...images].map((src, i) => {
            const title = titles[i % titles.length]
            return (
              <SwiperSlide key={i}>
                <Card image={src}>
                  <h3>{title}</h3>
                  <div>
                    <Button
                      equip="degraded"
                      size="small"
                      style={{ width: '150px', paddingBlock: 18, fontSize: 14 }}
                      onClick={() => handleRedirect(title)}
                    >
                      Ver productos
                    </Button>
                  </div>
                </Card>
              </SwiperSlide>
            )
          })}
        </RowSlider>
      )}
    </SliderContainer>
  )
}

export default CategorySlider
